<template>
  <div class="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center">
    <div class="bg-gray-800 rounded-lg p-6 text-center">
      <div class="loading-spinner w-8 h-8 mx-auto mb-4"></div>
      <p class="text-white">Loading...</p>
    </div>
  </div>
</template>